export default __webpack_public_path__ + "static/9-8af88d569d16a71841ce694d253337f9.webp";